import { render, staticRenderFns } from "./ClinicalPatientDetail.vue?vue&type=template&id=3741d5a2&scoped=true&"
import script from "./ClinicalPatientDetail.vue?vue&type=script&lang=js&"
export * from "./ClinicalPatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalPatientDetail.vue?vue&type=style&index=0&id=3741d5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3741d5a2",
  null
  
)

export default component.exports